import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Comment } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { memo } from "react";
import { useSelector } from "react-redux";
import { AssetModalPanel, useAssetModalPanelContext } from "~/providers/AssetModalPanelContextProvider";
import { centralizedClipOpenDiscussionCountSelector } from "~/store/centralizedClip/selectors";
export const MobileCommentsTab = /*#__PURE__*/ memo(()=>{
    const openDiscussionCount = useSelector(centralizedClipOpenDiscussionCountSelector);
    const { showPanel } = useAssetModalPanelContext();
    return /*#__PURE__*/ _jsxs("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ _jsx(IconButton, {
                "data-testid": "COMMENTS_PANEL",
                appearance: "ghost",
                color: "grey",
                icon: Comment,
                onClick: ()=>showPanel(AssetModalPanel.COMMENTS),
                size: "large",
                label: "Comments panel"
            }),
            !!openDiscussionCount && openDiscussionCount > 0 && /*#__PURE__*/ _jsx("div", {
                className: "absolute right-[7px] top-[7px] size-2.5 rounded-full bg-red-9"
            })
        ]
    });
});
MobileCommentsTab.displayName = "PrivateMobileCommentsTab";
